<template>
  <div
    class="m3-textbox m3p-textbox m3p-form__strong"
    :class="shouldDisplayError ? [`m3p-form__errorbox`] : null"
  >
    <text-field
      :id="fieldName"
      class="inquiry-form-textbox"
      v-model="inputValue"
      :name="fieldName"
      placeholder="例：やくざい"
      :validator="validator"
      :dispatcher="dispatcher"
    />
    <error-message :name="fieldName" />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useFieldError } from 'vee-validate';
import ErrorMessage from '@component_path/pages/pc/positions/show/common_components/form_element/ErrorMessage';
import TextField from '@component_path/pages/common/form/element/input';
import { useLastNameKanaField } from '@component_path/inquiry_form_common_module/custom_hook/LastNameKana';

const emit = defineEmits(['change']);

const inputValue = defineModel('inputValue');

const { validator, fieldName } = useLastNameKanaField(true);
const dispatcher = ref('positionInquiryMail/setLastNameKana');
const shouldDisplayError = useFieldError(fieldName.value);

watch(inputValue, newValue => emit('change', fieldName.value, newValue));
</script>
